import { SharedAppState } from '@libs/common/store/store.interface';
import { createSelector } from '@ngrx/store';

export const selectAuthState = (state: SharedAppState) => state.auth;

export const currentUser = createSelector(selectAuthState, ({ user }) => user);
